export const SET_EVENTS = 'SET_EVENTS'
export const ADD_EVENT = 'ADD_EVENT'
export const SET_ACTIVE_EVENT = 'SET_ACTIVE_EVENT'
export const DELETE_EVENT = 'DELETE_EVENT'
export const SET_EDIT_EVENT_MODE = 'SET_EDIT_EVENT_MODE'
export const CHANGE_EVENT = 'CHANGE_EVENT'
export const SET_MESSAGES = 'SET_MESSAGES'
export const ADD_MESSAGE = 'ADD_MESSAGE'
export const DELETE_MESSAGE = 'DELETE_MESSAGE'
